export enum HardwareItemUnit {
    Pounds = 'lbs',
    Grams = 'g',
    Feet = 'ft',
    Inches = 'in',
    Pieces = 'pcs',
    Gallons = 'gal',
    Ounces = 'oz',
    Packages = 'pkg'
}